<template>
  <div>
    <div v-if="bookingHasNoShortlistedTalent" class="no-stars">
      <p>
        There are no {{ $t('shortlisted stars') }}.
      </p>
    </div>
    <ul v-else class="shortlist shortlist-horizontal shortlist-col-4">
      <booking-search-details-list-item
        v-for="user in bookingShortlistedTalent"
        :key="user.id"
        :user="user"/>
    </ul>
  </div>
</template>

<script>
import { helpers } from 'mixins/bookings'
import BookingSearchDetailsListItem from './BookingSearchDetailsListItem'

export default {
  mixins: [helpers],

  components: {
    BookingSearchDetailsListItem
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>
